import React from 'react';
import { FormsyTime } from 'formsy-material-ui';

const TimePicker = ({floatingLabelText, ...props}) => (
    <FormsyTime
        {...props}
        floatingLabelText={floatingLabelText && (`${floatingLabelText} ${props.required ? " *" : ""}`)}
        className="input-field timepicker"
        format="24hr"
        fullWidth={true}
    />
);

export default TimePicker;
